import apiClient from '../api/apiClient';
import {ResponseDto} from "./ResponseDto";
import {TermsAgreeTypes, TermsTypes} from "../types/terms.types";



export const getMemberAuthTermsList = () =>
    apiClient.get<ResponseDto<TermsTypes[]>>("/api/front/terms/getMemberAuthTermsList");


export const getMemberTermsMstList = () =>
    apiClient.get<ResponseDto<TermsTypes[]>>("/api/front/terms/getMemberTermsMstList");


export const getMemberTermsAndAgreeInfoList = (termsGroupCode: string) =>
    apiClient.get<ResponseDto<TermsAgreeTypes[]>>("/api/front/terms/getMemberTermsAndAgreeInfoList",
        {
            params: {termsGroupCode},
            headers: {'Content-Type': 'application/json'},
        }
    );